
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-terrain_provider",
  "use": "icon-rescls-terrain_provider-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-terrain_provider\"><path fill=\"#7caed6\" d=\"m17 16.563 5-2.287-5-7.755z\" /><path fill=\"#699ec9\" d=\"m17 16.563 5-2.287-5-1.088z\" /><path fill=\"#c1d5e0\" d=\"M17 16.563 12 14.9l5-8.38z\" /><path fill=\"#b2cbd8\" d=\"M17 16.563 12 14.9l5-1.713z\" /><path fill=\"#7caed6\" d=\"m9.5 20 7.5-3.429L9.5 4z\" /><path fill=\"#c1d5e0\" d=\"M9.5 20 2 16.571 9.5 4z\" /><path fill=\"#699ec9\" d=\"m9.5 20 7.5-3.429L9.5 14z\" /><path fill=\"#b2cbd8\" d=\"M9.5 20 2 16.571 9.5 14z\" /><path fill=\"#75a9d3\" d=\"M14.003 11.546 12 14.901l4.994 1.659z\" /><path fill=\"#5c95bc\" d=\"M15.324 13.763 12 14.9l4.994 1.659z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-terrain_provider"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-terrain_provider";

        export default Icon;
    